module.exports = __webpack_public_path__ + "static/media/stable.efbe0c1e.svg";